import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_customer_review_queue_RowClass } from "../../dbschema";

export class GenericDocCustomerReviewQueueModel extends BaseContainerModel {

    bl_fi_generic_doc_customer_review_queue: bl_fi_generic_doc_customer_review_queue_RowClass = new bl_fi_generic_doc_customer_review_queue_RowClass();
}